import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=01a64521&"
import script from "./Public.vue?vue&type=script&lang=ts&"
export * from "./Public.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports